import React, { useEffect, useState } from "react";
import { Building2 } from "lucide-react";
import { ujmsDeptDashboard } from "../../services/ujmsApi";
import { Panel, Stat, thCls, tdCls, cls } from "../ui";

export default function Departments() {
  const [depts, setDepts] = useState([]);
  useEffect(() => { ujmsDeptDashboard().then((r) => setDepts(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-4" data-testid="departments-page">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight text-slate-900 flex items-center gap-2"><Building2 className="w-6 h-6" /> Department Dashboards</h1>
        <p className="text-sm text-slate-500">Per GO 1.2, the judiciary is organized into three departments. Each rollup shows its divisions' caseloads and hearing volume (next / last 30 days).</p>
      </div>
      {depts.map((d) => (
        <Panel key={d.id} title={d.department} testId={`dept-panel-${d.department.split(" ")[0].toLowerCase()}`}>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-3">
            <Stat label="Open cases" value={d.totals.open_cases} tone="text-blue-900" testId={`dept-open-${d.id}`} />
            <Stat label="Total cases" value={d.totals.total_cases} testId={`dept-total-${d.id}`} />
            <Stat label="Hearings next 30d" value={d.totals.hearings_next_30d} tone="text-amber-700" testId={`dept-upcoming-${d.id}`} />
            <Stat label="Hearings held (30d)" value={d.totals.hearings_held_30d} tone="text-emerald-700" testId={`dept-held-${d.id}`} />
          </div>
          <table className="w-full border-collapse">
            <thead><tr><th className={thCls}>Division</th><th className={thCls}>Open Cases</th><th className={thCls}>Total Cases</th><th className={thCls}>Hearings Next 30d</th><th className={thCls}>Hearings Held (30d)</th><th className={thCls}>Load</th></tr></thead>
            <tbody>
              {d.divisions.map((dv) => {
                const max = Math.max(1, ...d.divisions.map((x) => x.open_cases));
                return (
                  <tr key={dv.name} className="hover:bg-slate-50" data-testid={`dept-div-row-${dv.name.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}>
                    <td className={`${tdCls} font-medium`}>{dv.name}</td>
                    <td className={`${tdCls} font-mono text-sm font-semibold text-blue-900`}>{dv.open_cases}</td>
                    <td className={`${tdCls} font-mono text-sm`}>{dv.total_cases}</td>
                    <td className={`${tdCls} font-mono text-sm`}>{dv.hearings_next_30d}</td>
                    <td className={`${tdCls} font-mono text-sm`}>{dv.hearings_held_30d}</td>
                    <td className={`${tdCls} w-48`}>
                      <div className="h-2 bg-slate-100 rounded-sm overflow-hidden">
                        <div className={cls("h-full", dv.open_cases / max > 0.66 ? "bg-red-500" : dv.open_cases / max > 0.33 ? "bg-amber-500" : "bg-emerald-500")}
                          style={{ width: `${Math.round((dv.open_cases / max) * 100)}%` }} />
                      </div>
                    </td>
                  </tr>
                );
              })}
              {!d.divisions.length && <tr><td colSpan={6} className={`${tdCls} text-slate-400`}>No divisions assigned.</td></tr>}
            </tbody>
          </table>
        </Panel>
      ))}
      {!depts.length && <div className="text-sm text-slate-400">Loading department rollups…</div>}
    </div>
  );
}
